import {createContext, type PropsWithChildren, use} from 'react'
import type {AzureModelClient} from '../../../utils/azure-model-client'
import invariant from 'tiny-invariant'

const ModelClientContext = createContext<AzureModelClient | null>(null)

export const ModelClientProvider = ({modelClient, children}: PropsWithChildren<{modelClient: AzureModelClient}>) => {
  return <ModelClientContext value={modelClient}>{children}</ModelClientContext>
}

export function useModelClient() {
  const context = use(ModelClientContext)
  invariant(context, 'Expected a ModelClientProvider')
  return context
}
